import { createRouter, createWebHistory } from 'vue-router'
import { getToken } from '../utils/auth'

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index/index.vue')
  },
  // 儿童个人信息保护规则
  {
    path: '/privacy/infoProtectionChild',
    name: 'infoProtectionChild',
    component: () => import('../views/privacy/infoProtectionChild.vue')
  },
  // 英语儿童个人信息保护规则
  {
    path: '/privacy/english/infoProtectionChild',
    name: 'infoProtectionChild-english',
    component: () => import('../views/privacy/english/infoProtectionChild.vue')
  },
  // 个人信息收集清单
  {
    path: "/privacy/personalInfo",
    name: "personalInfo",
    component: () => import('../views/privacy/personalInfo.vue')
  },
  // 英语个人信息收集清单
  {
    path: "/privacy/english/personalInfo",
    name: "personalInfo-english",
    component: () => import('../views/privacy/english/personalInfo.vue')
  },
  // 九章随时问接入第三方SDK清单
  {
    path: "/privacy/thirdInfo",
    name: 'thirdInfo',
    component: () => import('../views/privacy/thirdInfo.vue')
  },
  // 英语接入第三方SDK清单
  {
    path: "/privacy/english/thirdInfo",
    name: 'thirdInfo-english',
    component: () => import('../views/privacy/english/thirdInfo.vue')
  },
  // 用户个人信息保护政策
  {
    path: "/privacy/userPersonalInfo",
    name: 'userPersonalInfo',
    component: () => import('../views/privacy/userPersonalInfo.vue')
  },
  // 英语用户个人信息保护政策
  {
    path: "/privacy/english/userPersonalInfo",
    name: 'userPersonalInfo-english',
    component: () => import('../views/privacy/english/userPersonalInfo.vue')
  },
  // 用户个人信息保护政策摘要
  {
    path: "/privacy/policy_summary_hw",
    name: "policy_summary_hw",
    component: () => import('../views/privacy/policy_summary_hw.vue')
  },
  // 调用的权限
  {
    path: "/privacy/permissionList",
    name: "permissionList",
    component: () => import('../views/privacy/permissionList.vue')
  },
  // 英语调用的权限
  {
    path: "/privacy/english/permissionList",
    name: "permissionList-english",
    component: () => import('../views/privacy/english/permissionList.vue')
  },
  // 注销账号
  {
    path: "/privacy/accountCancellation",
    name: "accountCancellation",
    component: () => import('../views/privacy/accountCancellation.vue')
  },
  // 用户协议
  {
    path: "/privacy/userAgreement",
    name: "userAgreement",
    component: () => import('../views/privacy/userAgreement.vue')
  },
  // 英语用户协议
  {
    path: "/privacy/english/userAgreement",
    name: "userAgreement-english",
    component: () => import('../views/privacy/english/userAgreement.vue')
  },
  // ios静态图片
  {
    path: '/app/ios',
    name: 'ios静态图片',
    component: () => import('../views/ios/staticPicture.vue')
  },
  //跳转应用商店下载页面
  {
    path: '/app',
    name: '替换',
    component: () => import('../views/download/download.vue')
  },

  // 华为小艺专用协议
  // 儿童个人信息保护规则
  {
    path: '/privacy/xy/infoProtectionChild',
    name: 'infoProtectionChild-xy',
    component: () => import('../views/privacy/xy/infoProtectionChild.vue')
  },
  // 用户协议
  {
    path: "/privacy/xy/userAgreement",
    name: "userAgreement-xy",
    component: () => import('../views/privacy/xy/userAgreement.vue')
  },
  // 用户个人信息保护政策
  {
    path: "/privacy/xy/userPersonalInfo",
    name: 'userPersonalInfo-xy',
    component: () => import('../views/privacy/xy/userPersonalInfo.vue')
  },
  // 练习场
  {
    path: "/practice/index",
    name: 'practice-index',
    component: () => import('../views/practice/index.vue')
  },
    // 练习场
  {
    path: "/practiceSc/index",
    name: 'practiceSc-index',
    component: () => import('../views/practiceSc/index.vue')
  },
  {
    path: "/practice/inapp",
    name: 'practice-inapp',
    component: () => import('../views/practice/inapp.vue')
  },
  // 招募体验官H5页
  {
    path: "/landing/apply-experience-officer",
    name: 'landing-apply-experience-officer',
    component: () => import('../views/landing/apply-experience-officer/index.vue')
  },

  // YJXY
  // 用户个人信息保护政策
  {
    path: "/privacy/yjxy/userPersonalInfo",
    name: 'userPersonalInfo-yjxy',
    component: () => import('../views/privacy/yjxy/userPersonalInfo.vue')
  },
  {
    path: "/privacy/yjxy/plan/userPersonalInfo",
    name: 'userPersonalInfo-yjxy-plan',
    component: () => import('../views/privacy/yjxy/plan/userPersonalInfo.vue')
  },
  // bridge 调试 demo
  {
    path: "/demo",
    name: 'Demo',
    component: () => import('../views/demo/index.vue')
  },
  // 集卡活动规则页
  {
    path: "/activity/cardCollection/rule",
    name: 'Rule',
    component: () => import('../views/activity/cardCollection/rule.vue')
  },
  // 通用banner的H5页
  {
    path: "/ad",
    name: 'ad',
    component: () => import('../views/ad/index.vue')
  },
  // 集卡活动2规则页
  {
    path: "/activity/cardCollectionV2/rule",
    name: 'activityRule',
    component: () => import('../views/activity/cardCollectionV2/rule.vue')
  },
  // 集卡活动2首页
  {
    path: "/activity/cardCollectionV2/index",
    name: 'activityIndex',
    component: () => import('../views/activity/cardCollectionV2/index.vue')
  },
  // 集卡活动2地址页
  {
    path: "/activity/cardCollectionV2/address",
    name: 'activityAddress',
    component: () => import('../views/activity/cardCollectionV2/address.vue')
  },
  // 打卡活动首页
  {
    path: "/activity/checkInActivity/index",
    name: 'checkInActivityIndex',
    component: () => import('../views/activity/checkInActivity/index.vue')
  },
    // 打卡活动报名信息页
  {
    path: "/activity/checkInActivity/registration",
    name: 'checkInActivityAddress',
    component: () => import('../views/activity/checkInActivity/registration.vue')
  },
    // 打卡活动规则页
  {
    path: "/activity/checkInActivity/rule",
    name: 'checkInActivityRule',
    component: () => import('../views/activity/checkInActivity/rule.vue')
  },

  // 集卡活动3规则页
  {
    path: "/activity/cardCollectionV3/rule",
    name: 'activityRuleV3',
    component: () => import('../views/activity/cardCollectionV3/rule.vue')
  },
  // 集卡活动3首页
  {
    path: "/activity/cardCollectionV3/index",
    name: 'activityIndexV3',
    component: () => import('../views/activity/cardCollectionV3/index.vue')
  },
  // 集卡活动3地址页
  {
    path: "/activity/cardCollectionV3/address",
    name: 'activityAddressV3',
    component: () => import('../views/activity/cardCollectionV3/address.vue')
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

// router.beforeEach((to, from, next) => {
//   if (to.path !== '/login' && !getToken()) {
//     next('/login')
//   } else if (to.path === '/login' && getToken()) {
//     next('/login')
//   } else {
//     next()
//   }
// })

export default router
